import { UISDK } from "@/ui-sdk";

export default function handleSimilarInlineBlock(
  element: HTMLElement,
  sdk: UISDK,
) {
  const data = {
    product: {
      handle: "hello",
    },
  };
  const val = element.getAttribute("data-helium-product-handle");
  if (!val || val !== data.product.handle) {
    console.log("Product handle mismatch or not found.");
    return;
  }
  const targetElement = document.querySelector(
    `[data-helium-product-handle="${val}"]`,
  );
  if (!targetElement) {
    console.log(`Element with handle ${val} not found.`);
    return;
  }
  const newElement = document.createElement("div");
  targetElement.insertAdjacentElement("afterend", newElement);
  sdk.renderSimilarInlineBlock(newElement, val);
}
